<div class="dlg">
  <header class="dlg__hdr">
    <h2>{{ reportFiltersDialog()?.title }}</h2>
    <button (click)="close()" aria-label="Cerrar" class="icon-btn">✕</button>
  </header>
  <div class="dlg__divider"></div>

  <section class="dlg__body">
    <div class="content-section">
      <app-reporte-filtros [disableCategories]="disableCategories"></app-reporte-filtros>
    </div>
  </section>

  <footer class="dlg__ftr">
    <button (click)="close()" class="btn btn--muted" type="button">{{ reportFiltersDialog()?.cancelButton }}</button>

    <button class="btn" type="button"
            (click)="applyFromHost()"
            [disabled]="!child?.hasActiveFilters">
      {{ reportFiltersDialog()?.applyButton }}
    </button>
  </footer>
</div>
